<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/Settings/ApiTest/index'

export default {
  components: {
    MainComponent
  },

  data () {
    return {
      modelName: 'settings/apiTest'
    }
  },

  created () {
    this.$store.commit(`settings/setAttr`, {
      name: 'menuSelected',
      value: 'api-test'
    })
    this.$store.dispatch(`${this.modelName}/getCollections`)
  }
}
</script>
